import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactForm from "../../main-component/HireUsPage/HireUsContactForm";

import contactBg from "../../images/bg/contact-bg02.png";

const HireUs: React.FC = () => {
  return (
    <Fragment>
      <div className="about-page inner-page hireus-page">
        <div className="body_wrap o-clip">
          <Header />

          <main>
            <PageTitle pageTitle="Hire Us" pagesub="Hire Us" />

            <section className="contact">
              <div className="container">
                <div
                  className="xb-contact-wrap xb-border bg_img"
                  style={{ backgroundImage: `url(${contactBg})` }}
                >
                  <div className="xb-contact-form xb-main-contact xb-border">
                    <div className="form-heading text-center mb-30">
                      <h3 className="title">Tell Us About Your Project</h3>
                      <p className="sub-title clr-white">
                        We usually respond within 24 hours.
                      </p>
                    </div>

                    {/* SAME FORM – NO CHANGE */}
                    <ContactForm />
                  </div>
                </div>
              </div>
            </section>
          </main>

          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HireUs;
